import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TopNavbarComponent } from '@app/shared/components/top-navbar/top-navbar.component';
import { TranslatePipe } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { LoyaltyClubFooterComponent } from '@app/shared/components/loyalty-club-footer/loyalty-club-footer.component';
import { AlertComponent } from '@app/shared/components/alert/alert.component';

@Component({
  selector: 'app-update-confirmation',
  templateUrl: './update-confirmation.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TopNavbarComponent,
    TranslatePipe,
    RouterLink,
    LoyaltyClubFooterComponent,
    AlertComponent,
  ],
})
export class UpdateConfirmationComponent {}
